import SkillList from '@/controllers/skill/skill-list.js';

export default {
  extends: SkillList,
}
